import React, { useCallback, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import { RootStateTypeExtra } from '@store/types'

import { CheckSvg, LoadingSvg } from '@svg/react'

interface ProjectListItemProps {
  canonicalName: string
  label: string
  isProcessing?: boolean
  onClick: () => void
}

function ProjectListItem({
  canonicalName,
  label,
  isProcessing,
  onClick,
}: ProjectListItemProps) {
  const activeProject = useSelector(
    (state: RootStateTypeExtra) => state.projectIdentity.projectName
  )
  const [isSwitching, setIsSwitching] = useState(false)
  const isActive = activeProject === canonicalName
  const showLoader = isProcessing && isSwitching

  const handleClick = useCallback(() => {
    if (isActive) {
      return
    }
    onClick()
    setIsSwitching(true)
  }, [isActive, onClick])

  useEffect(() => {
    if (!isProcessing) {
      setIsSwitching(false)
    }
  }, [isProcessing])

  return (
    <button
      className={`flex items-center gap-4 px-[14px] py-[10px] ${isActive ? 'cursor-auto rounded-full bg-white text-[#081C34]' : 'text-white'}`}
      type="button"
      onClick={handleClick}
    >
      <p className="m-0 whitespace-nowrap text-sm font-semibold leading-[18px]">
        {label}
      </p>
      {isActive && (
        <CheckSvg className="ml-auto h-[10px] w-[14px] stroke-[#081C34]" />
      )}
      {showLoader && (
        <LoadingSvg className="ml-auto h-[14px] w-[14px] fill-[#081C34]" />
      )}
    </button>
  )
}

export default ProjectListItem
